import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Flex.scss';

export function FlexColumn({
	as: Component = 'div',
	children,
	className,
	gapSmall,
	alignCenter,
	...props
}) {
	return (
		<Component
			className={classnames(
				'flex-column',
				{
					'gap-small': gapSmall,
					'align-center': alignCenter,
				},
				className,
			)}
			{...props}
		>
			{children}
		</Component>
	);
}

FlexColumn.propTypes = {
	as: PropTypes.elementType,
	children: PropTypes.node,
	className: PropTypes.string,
	gapSmall: PropTypes.bool,
	alignCenter: PropTypes.bool,
};

FlexColumn.defaultProps = {
	gapSmall: false,
	alignCenter: false,
	as: 'div',
};
